import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true, timeout: 30000 });

export const mutationStats = { ok: 0, fail: 0 };
const isMutation = (cfg) => cfg && !["get", "head", "options"].includes((cfg.method || "get").toLowerCase());

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("crank_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => { if (isMutation(r.config)) mutationStats.ok += 1; return r; },
  (error) => {
    if (isMutation(error.config)) mutationStats.fail += 1;
    const d = error.response?.data?.detail;
    if (error.response?.status === 403 && d && typeof d === "object" && d.banned) {
      localStorage.setItem("ban_info", JSON.stringify(d));
      localStorage.removeItem("crank_token");
      if (!window.location.pathname.startsWith("/suspended")) {
        window.location.href = "/suspended";
      }
    }
    return Promise.reject(error);
  }
);

export function apiErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

// Always returns a human-readable message for ANY axios error, including
// network failures, CORS blocks and timeouts (which have no `response`).
export function errMsg(error) {
  const res = error?.response;
  if (res) {
    const d = res.data?.detail ?? res.data?.message;
    if (d != null) return apiErr(d);
    return `Request failed (HTTP ${res.status}).`;
  }
  if (error?.code === "ECONNABORTED") return "Request timed out — the server didn't respond.";
  if (error?.message === "Network Error") return "Network error — couldn't reach the server (check the API URL / connection).";
  return error?.message || "Something went wrong.";
}

export default api;
